// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__nOVvb","timer_circle":"Timer_timer_circle__o0RqL","timer_text":"Timer_timer_text__fTjby"};